"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getIconButtonUtilityClass = getIconButtonUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getIconButtonUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriIconButton', slot);
}
const iconButtonClasses = (0, _base.generateUtilityClasses)('MuiOriIconButton', ['colorDefault', 'colorError', 'colorInherit', 'colorPrimary', 'colorSecondary', 'contained', 'disabled', 'edgeEnd', 'edgeStart', 'focusVisible', 'iconSizeMedium', 'iconSizeSmall', 'loading', 'loadingIndicator', 'loadingWrapper', 'outlined', 'root', 'sizeLarge', 'sizeMedium', 'sizeSmall', 'text']);
var _default = exports.default = iconButtonClasses;
